export const EXPENSE_CATEGORIES = [
  { value: 'fuel',       label: 'Fuel' },
  { value: 'washing',    label: 'Vehicle Washing' },
  { value: 'municipal',  label: 'Municipal Fee' },
  { value: 'parking',    label: 'Parking Fee' },
  { value: 'night_out',  label: 'Night Out Allowance' },
  { value: 'spares',     label: 'Spare Parts' },
  { value: 'brake_pads', label: 'Brake Pads' },
  { value: 'insurance',  label: 'Insurance' },
  { value: 'nhif',       label: 'NHIF' },
  { value: 'sacco_fee',  label: 'Sacco Fee' },
  { value: 'other',      label: 'Other' },
];

export const VEHICLE_STATUSES = ['active', 'inactive', 'under_maintenance'];
export const TRIP_STATUSES    = ['in_progress', 'completed', 'cancelled'];
export const LEAVE_STATUSES   = ['approved', 'cancelled'];

export const USER_ROLES = { OWNER: 'owner', DRIVER: 'driver' };